<template>
  <div>
    <div
      class="limit-online-text"
      v-if="$store.state.plan && ($store.state.plan.group == 'pro'
        || $store.state.plan.group == 'white-label')"
    >
      <span
        v-html="$i18nPresenter.t('youCanHostUpto', {
          x: ($store.state.plan.limit)
        })"
      ></span>

      <a
        href="https://ahaslides.com/contact-us"
        target="_blank"
        class="ml-1"
      > {{ $i18nPresenter.t('Contact us') }}</a>.
    </div>

    <div
      class="limit-online-text"
      v-if="$store.state.plan.group != 'pro' && !currentUser.oneTimeEnd
        && $store.state.plan.group != 'white-label'
        && !isGuestUser"
    >
      <span v-if="$store.state.plan.group == 'free'">
        <span
          v-html="$i18nPresenter.t('asAFreeUserYouCanHostUpto', {
            x: ($store.state.plan.limit)
          })"
        ></span>
        <span class="cursor-pointer text-primary-90 ml-1" @click="goToUpgrade()">
          {{ $i18nPresenter.t('Upgrade from just $7.95.') }}
        </span>
      </span>
      <span v-else-if="$store.state.plan.group == 'one-time'">
        <span></span>
        <span
          v-html="$i18nPresenter.t('youCanHostUptoOnYourEventday', {
            x: ($store.state.plan.limit)
          })"
        ></span>
        <i
          class="fas fa-question-circle"
          v-tooltip="oneTimeTooltip"
        />&nbsp;
        <span>
          {{ $i18nPresenter.t('Need more?') }}
          <a @click="goToUpgrade()">{{ $i18nPresenter.t('Upgrade now') }}</a>.
        </span>
      </span>
      <span v-else>
        <span></span>
        <span
          v-html="$i18nPresenter.t('youCanHostUpto', {
            x: ($store.state.plan.limit)
          })"
        ></span>
        <span>
          <a @click="goToUpgrade()">{{ $i18nPresenter.t('Upgrade now') }}</a>.
        </span>
      </span>
    </div>
    <div
      class="limit-online-text"
      v-if="$store.state.plan.group == 'one-time' && currentUser.oneTimeEnd"
    >
      {{ $i18nPresenter.t('Your event day has started.') }}
      {{ $i18nPresenter.t('You can host up to') }}
      <strong>{{ $store.state.plan.limit | formatNumber }}</strong> {{ $i18nPresenter.t('live participants until') }}
      <strong>{{ currentUser.oneTimeEnd | dateTimeFirst }}</strong>.
      <br>{{ $i18nPresenter.t('Need more?') }}
      <a @click="goToUpgrade()" class="ml-1">{{ $i18nPresenter.t('Upgrade now') }}</a>.
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'

// services
import cookie from '@/services/cookie'

export default {
  data() {
    return {
      isGuestUser: !!cookie.getValue('aha-guest-user'),
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
      slideActive: (state) => state.slideActive,
      sharePresentation: (state) => state.sharePresentation,
      isNewPresentation: (state) => state.isNewPresentation,
    }),
    oneTimeTooltip() {
      return this.$i18nPresenter.t('Your event day will start when you have more than 7 participants joining your presentation simultaneously and last for 24 hours')
    },
  },
  methods: {
    goToUpgrade() {
      // add redirect to handle case: guest clicks upgrade -> go to sign-up first
      this.$router.push('/apps/user-plan?redirect=/apps/user-plan')
      utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Feature upgrade',
        'Middle participant limit',
      )
    },

  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.limit-online-text {
  font-size: 13px;
  text-align: center;
  padding-bottom: 12px;
  color: $suva-grey-color;
  max-width: 680px;
  margin: 0 auto;
  font-family: "Nunito", sans-serif;

  a {
    font-weight: bold;
    cursor: pointer;
    color: $primary-color;

    &:hover {
      color: $primary-hover-color;
      text-decoration: underline;
    }
  }
}
</style>
